import { AnyVariables, OperationResult } from 'urql';

import { UseCartResult } from 'hooks/useCart';
import { ActiveCart, ActiveCartItem } from 'types/cart';
import { RemoveItemFromCartMutation } from '__generated__/graphql';

import { SelectedItemType } from '../types';

// Removes items one at a time to keep cart in sync
export const handleRemoveItemFromCart = async (
  itemsToRemove: SelectedItemType[],
  cart: ActiveCart,
  doesSelectedItemMatchInCartItemCallback: (
    selected: SelectedItemType,
    inCart: ActiveCartItem
  ) => boolean,
  removeFromCart: UseCartResult['removeFromCart']
): Promise<
  OperationResult<RemoveItemFromCartMutation, AnyVariables> | undefined
> => {
  if (!cart?.products) return;

  let res:
    | OperationResult<RemoveItemFromCartMutation, AnyVariables>
    | undefined = undefined;
  for (const itemToRemove of itemsToRemove) {
    const itemToRemoveInCart = cart.products.find(inCartItem =>
      doesSelectedItemMatchInCartItemCallback(itemToRemove, inCartItem)
    );
    if (!itemToRemoveInCart) return;
    res = await removeFromCart({
      itemId: itemToRemoveInCart.id,
    });
  }

  return res;
};
